import api from './base/BaseApi';
import { handleApiError } from './base/handleApiError';
import {
  IGetPendingInvitationResponse,
  IGetTeamMembersResponse,
  RqCreatePendingInvitation,
  RqUpdateMemberAccessLevel,
  RqUpdatePendingInvitation,
  RqUpdateTeamMemberAccountStatus
} from './types/Business';

export const getTeamMembers = async (businessId: string) =>
  api
    .get<IGetTeamMembersResponse[]>(`/api/v1/businesses/${businessId}/members`)
    .then((response) => response)
    .catch(handleApiError);

export const updateMemberAccessLevel = async (
  businessId: string,
  customerId: string,
  accessLevel: string
) =>
  api
    .patch<unknown, RqUpdateMemberAccessLevel>(
      `/api/v1/businesses/${businessId}/members/${customerId}`,
      { accessLevel }
    )
    .then((response) => response)
    .catch(handleApiError);

export const updateMemberStatus = async (businessId: string, customerId: string, status: string) =>
  api
    .put<unknown, RqUpdateTeamMemberAccountStatus>(
      `/api/v1/businesses/${businessId}/members/${customerId}/status`,
      { status }
    )
    .then((response) => response)
    .catch(handleApiError);

// roles=employee scopes this to team-member invites only - excludes director/shareholder/officer
// pending invitations, which are a different concept this feature has no business showing.
export const getPendingInvitations = async (businessId: string) =>
  api
    .get<IGetPendingInvitationResponse[]>(
      `/api/v1/businesses/${businessId}/pending-invitations?roles=employee`
    )
    .then((response) => response)
    .catch(handleApiError);

export const createPendingInvitation = async (
  businessId: string,
  body: RqCreatePendingInvitation
) =>
  api
    .post<IGetPendingInvitationResponse, RqCreatePendingInvitation>(
      `/api/v1/businesses/${businessId}/pending-invitations`,
      body
    )
    .then((response) => response)
    .catch(handleApiError);

export const updatePendingInvitation = async (
  businessId: string,
  pendingInvitationId: string,
  body: RqUpdatePendingInvitation
) =>
  api
    .patch<IGetPendingInvitationResponse, RqUpdatePendingInvitation>(
      `/api/v1/businesses/${businessId}/pending-invitations/${pendingInvitationId}`,
      body
    )
    .then((response) => response)
    .catch(handleApiError);

export const deletePendingInvitation = async (businessId: string, pendingInvitationId: string) =>
  api
    .delete(`/api/v1/businesses/${businessId}/pending-invitations/${pendingInvitationId}`)
    .then((response) => response)
    .catch(handleApiError);
